import React, { useState, useContext, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import useTheme from "./useTheme";
import Modal from "react-bootstrap/Modal";
import { LoginContext } from "../context/LoginContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";

const Order = (props) => {
  const [showOrder, setShowOrder] = useState(false);

  const [showMsg, setShowMsg] = useState(false);

  const [showOrderDetail, setShowOrderDetail] = useState(false);

  const [orderDetail, setOrderDetail] = useState({});

  const [orders, setOrders] = useState([]);

  const [notRead, setNotRead] = useState(0);

  const [image, setImage] = useState({ preview: "", raw: "" });

  const [msg, setMsg] = useState([true, ""]);

  const [tozih, setTozih] = useState("");

  const [isRead, setIsRead] = useState(false);

  const loginContext = useContext(LoginContext);

  const [theme, switchTheme] = useTheme();

  useEffect(() => {
    if (loginContext.userInfo.isModir) {
      const form = new FormData();
      form.append("getMoshtariOrder", 1);
      form.append("vitrinCode", props.vitrinCode);
      const req = new Request(
        "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
        {
          method: "POST",
          body: form,
        }
      );
      fetch(req)
        .then((res) => res.json())
        .then((data) => {
          if (data.data === null) {
            setOrders([]);
          } else {
            setOrders(data.data);
            if (data.data.length > 0) {
              const array = [];
              data.data.map((item) => {
                if (parseInt(item.isRead) === 0) {
                  array.push(item);
                }
              });
              setNotRead(array.length);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [isRead]);

  const handleChange = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
    console.log(e.target.files[0]);
  };

  const remove = () => {
    setImage({
      preview: "",
      raw: "",
    });
  };

  const tozihHandle = (e) => {
    setTozih(e.target.value);
  };

  const sendOrder = () => {
    if (
      image.raw === "" ||
      image.raw === undefined ||
      image.raw === null ||
      tozih === ""
    ) {
      setShowMsg(true);
      setMsg(false, "لطفا همه فیلد ها را پر کنید");
    } else {
      const form = new FormData();
      form.append("setMoshtariOrder", 1);
      form.append("vitrinCode", props.vitrinCode);
      form.append("mobile", loginContext.userInfo.mobile);
      form.append("tozih", tozih);
      form.append("file", image.raw);
      const requ = new Request(
        "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
        {
          method: "POST",
          body: form,
        }
      );
      fetch(requ)
        .then((res) => res.json())
        .then((data) => {
          setShowMsg(true);
          setMsg([data.result, data.data]);
          setTozih("");
          setImage({ preview: "", raw: "" });
        })
        .catch((err) => {
          console.log(err);
          setShowMsg(true);
          setMsg([false, "اشکال در برقراری ارتباط با سرور"]);
        });
    }
  };

  const setOrderRead = (pk) => {
    const form = new FormData();
    form.append("setOrderRead", 1);
    form.append("pkOrder", pk);
    const requ = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(requ)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          setIsRead(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (loginContext.userInfo.isModir) {
    return (
      <>
        <Nav.Link
          onClick={() => {
            setShowOrder(true);
          }}
          href="#"
          className={theme === "light" ? "text-dark" : "text-light"}
        >
          {" سفارش دلخواه مشتری "}
          {notRead > 0 ? (
            <span className="badge badge-info">{notRead}</span>
          ) : null}
        </Nav.Link>

        <Modal
          show={showOrder}
          onHide={() => setShowOrder(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            سفارش دلخواه مشتری
          </Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            {orders.length > 0 ? (
              <>
                <table
                  className={
                    theme === "light"
                      ? "table table-hover rtl text-dark"
                      : "table table-hover rtl text-light"
                  }
                >
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">توضیح</th>
                      <th scope="col">مشتری</th>
                      <th scope="col">تصویر</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((item, index) => (
                      <tr
                        key={index}
                        className={
                          item.isRead == 0 ? "table-info text-dark" : ""
                        }
                        onClick={() => {
                          setOrderDetail(item);
                          setShowOrderDetail(true);
                          setOrderRead(item.pkMoshtariOrder);
                        }}
                      >
                        <th scope="row">{index + 1}</th>
                        <td>
                          {item.tozih.length < 20
                            ? item.tozih
                            : item.tozih.substring(0, 20) + "..."}
                        </td>
                        <td>{item.name}</td>
                        <td>
                          <img
                            src={item.image}
                            style={{ width: "50px", height: "auto" }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            ) : (
              <>
                <h6 className="text-center"> سفارشی یافت نشد</h6>
              </>
            )}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => {
                setShowOrder(false);
              }}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>

        {/* detail modal */}

        <Modal
          show={showOrderDetail}
          onHide={() => {
            setShowOrderDetail(false);
            setIsRead(false);
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            سفارش دلخواه مشتری
          </Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <div className="text-center">
              <img
                className="m-3"
                style={{ width: "300px", heith: "auto" }}
                src={orderDetail.image}
              />
            </div>
            <h5 className="text-center mt-3">توضیح</h5>
            <p className="text-center mt-2">{orderDetail.tozih}</p>

            <h5 className="text-center mt-3">نام مشتری</h5>
            <p className="text-center mt-2">{orderDetail.name}</p>

            <h5 className="text-center mt-3">موبایل مشتری</h5>
            <p className="text-center mt-2">{orderDetail.mobile}</p>

            <h5 className="text-center mt-3">تاریخ ارسال سفارش</h5>
            <p className="text-center mt-2">{orderDetail.date}</p>
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => {
                setShowOrderDetail(false);
                setIsRead(false);
              }}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  } else {
    return (
      <>
        <Nav.Link
          onClick={() => {
            setShowOrder(true);
          }}
          href="#"
          className={theme === "light" ? "text-dark" : "text-light"}
        >
          سفارش دلخواه من
        </Nav.Link>
        <Modal
          show={showOrder}
          onHide={() => setShowOrder(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            سفارش دلخواه من
          </Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <div className="d-flex justify-content-center mt-3">
              <label htmlFor="upload-button">
                {image.preview ? (
                  <div>
                    <img
                      src={image.preview}
                      alt="upload"
                      width="300"
                      height="300"
                    />
                    <div className="d-flex justify-content-center mt-3">
                      <button className="btn btn-danger" onClick={remove}>
                        حذف
                      </button>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      border: "1px black solid",
                      borderRadius: "5px",
                      padding: "3px",
                    }}
                  >
                    <FontAwesomeIcon icon={faUpload} />
                    آپلود تصویر
                  </div>
                )}
              </label>
              <input
                type="file"
                id="upload-button"
                style={{ display: "none" }}
                onChange={handleChange}
              />
            </div>
            <div className="mt-3">
              <textarea
                className={"form-control rtl"}
                placeholder="توضیحات"
                value={tozih}
                onChange={tozihHandle}
              />
            </div>
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button className="btn btn-success" onClick={() => sendOrder()}>
              ارسال سفارش
            </button>
            <button
              className="btn btn-dark"
              onClick={() => setShowOrder(false)}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showMsg}
          onHide={() => setShowMsg(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          ></Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <h5
              className={
                msg[0]
                  ? "mt-3 text-center text-dark"
                  : "mt-3 text-center text-danger"
              }
            >
              {msg[1]}
            </h5>
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button className="btn btn-dark" onClick={() => setShowMsg(false)}>
              بستن
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
};

export default Order;
